function createReferencePart(referenceNumber, label, references) {
	const reference = references[referenceNumber - 1];
	const href =
		typeof reference?.pmid === "string" ? reference.pmid.trim() : "";

	if (!href) {
		return null;
	}

	return {
		href,
		label,
		referenceNumber,
		title: typeof reference.cit === "string" ? reference.cit.trim() : "",
	};
}

function splitReferenceGroup(groupLabel, groupContent, references) {
	const numberPattern = /\d+/g;
	const numberMatches = [...groupContent.matchAll(numberPattern)];

	if (numberMatches.length === 1) {
		const referenceNumber = Number(numberMatches[0][0]);
		const referencePart = createReferencePart(
			referenceNumber,
			groupLabel,
			references,
		);

		return referencePart ? [referencePart] : [groupLabel];
	}

	const parts = ["["];
	let previousIndex = 0;

	numberMatches.forEach((numberMatch) => {
		const numberLabel = numberMatch[0];
		const numberIndex = numberMatch.index;

		if (numberIndex > previousIndex) {
			parts.push(groupContent.slice(previousIndex, numberIndex));
		}

		parts.push(
			createReferencePart(Number(numberLabel), numberLabel, references) ??
				numberLabel,
		);
		previousIndex = numberIndex + numberLabel.length;
	});

	if (previousIndex < groupContent.length) {
		parts.push(groupContent.slice(previousIndex));
	}

	parts.push("]");
	return parts;
}

export function splitMessageTextByReferences(text, references) {
	if (
		typeof text !== "string" ||
		!Array.isArray(references) ||
		references.length === 0
	) {
		return [text];
	}

	const parts = [];
	const referencePattern = /\[(\d+(?:\s*,\s*\d+)*)\]/g;
	let previousIndex = 0;
	let match = referencePattern.exec(text);

	while (match) {
		const referenceParts = splitReferenceGroup(match[0], match[1], references);
		const hasLinkedReference = referenceParts.some(
			(part) => typeof part !== "string",
		);

		if (hasLinkedReference) {
			if (match.index > previousIndex) {
				parts.push(text.slice(previousIndex, match.index));
			}
			parts.push(...referenceParts);
			previousIndex = referencePattern.lastIndex;
		}

		match = referencePattern.exec(text);
	}

	if (parts.length === 0) {
		return [text];
	}

	if (previousIndex < text.length) {
		parts.push(text.slice(previousIndex));
	}

	return parts;
}
